/**
 * Shared wallet / account display helpers for site + dashboard chrome.
 */

export function formatShortAddress(addr) {
  if (!addr || typeof addr !== "string") return "";
  const a = addr.trim();
  if (a.length < 10) return a;
  return `${a.slice(0, 6)}...${a.slice(-4)}`;
}

export function primaryLinkedWallet(user) {
  const list = Array.isArray(user?.wallets) ? user.wallets : [];
  const eth = list.filter(
    (w) =>
      w &&
      typeof w === "object" &&
      (!w.chain || w.chain === "ethereum") &&
      typeof w.address === "string" &&
      w.address.trim() !== ""
  );
  const p = eth.find((w) => w.isPrimary);
  return p || eth[0] || null;
}

export function isWalletOnlyAccount(user) {
  if (!user) return false;
  const providers = Array.isArray(user.authProviders) ? user.authProviders : [];
  return Boolean(!user.email && providers.includes("wallet"));
}

/** Short non-wallet label for header chips (email prefix or username). */
export function shortAccountLabel(user) {
  if (!user || isWalletOnlyAccount(user)) return "";
  if (user.username) return String(user.username).slice(0, 18);
  if (user.email) return String(user.email).split("@")[0].slice(0, 16);
  return "";
}
